import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid';

import SoundOff from '../components/soundOff/SoundOff';
import SoundOffSkeleton from '../util/SoundOffSkeleton';

import Profile from '../components/profile/Profile';
import { connect } from 'react-redux';
import { getSoundOffs } from '../redux/actions/dataActions';
import PropTypes from 'prop-types';
export class home extends Component {



    componentDidMount() {
        this.props.getSoundOffs();
    }


    render() {
        const { soundOffs, loading } = this.props.data;
        let recentSoundOffsMarkup = !loading ? (
            soundOffs.map((soundOff) => <SoundOff soundOff={soundOff} key={soundOff.soundOffId} />)
        ) : <SoundOffSkeleton />
        return (
            <Grid container spacing={6}>
                <Grid item sm={8} xs={12} >
                    {recentSoundOffsMarkup}
                </Grid>
                <Grid item sm={4} xs={12} >
                    <Profile />
                </Grid>
            </Grid>
        )
    }
}

home.propTypes = {
    getSoundOffs: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
    data: state.data
})

export default connect(mapStateToProps, { getSoundOffs })(home);
